import * as React from "react";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `0px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon className="accordian-arrow-icon" sx={{ fontSize: "0.5rem", color : "white"}} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? "rgba(255, 255, 255, .05)" : "#253746",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
  marginTop: "20px",
  borderRadius: "3px 3px 0 0",
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: '12px',
  margin:'auto',
  border: "1px solid rgba(0, 0, 0, .125)",
  borderRadius: "0 0 3px 3px",
}));

const AccordionTab: React.FC<AccordionProps> = ({ title, children }) => {
  const [expanded, setExpanded] = React.useState<string | false>("panel1");
  const handleAccordianChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  return (
    <Accordion
      defaultExpanded={true}
      onChange={handleAccordianChange("")}
    >
      <AccordionSummary >
        <Typography className="accordian-text-color">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails className="accordian-padding">{children}</AccordionDetails>
    </Accordion>
  );
};

export default AccordionTab;
